import React from 'react';

const Icon = ({ name, className = "", size = "1rem", ...props }) => {
  return (
    <i 
      className={`bi bi-${name} ${className}`} 
      style={{ fontSize: size }}
      {...props}
    />
  );
};

export default Icon;
